import { Component, OnInit, ViewChild} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { IAEventDocumentDetails } from '../../../../../shared/models/IAEventDocumentDetails';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-iaeventcompletion',
  templateUrl: './iaeventcompletion.component.html',
  styleUrl: './iaeventcompletion.component.css'
})
export class IaeventcompletionComponent implements OnInit {
  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();
  loadingSequence: boolean = false;
  eventUpdationForm: FormGroup;
  eventId: any;
  uploadError: string | null = null;
  fileErrors: { typeError: boolean; sizeError: boolean } = { typeError: false, sizeError: false };
  removedocumentuploadError: string | null = null;
  uploadAttError: string | null = null;
  result: any[] = [];
  data: any = {};
  //reportData: any[] = [];
  UniqueEventId: string = '';
  uniqueEventId: any;
  isSubmitting = false;
  selectedItems: any[] = []; // To store selected items
  document: { name: string, file: File | null }[] = [];
  attendanc: { name: string, file: File | null }[] = [];
  isSubmitted = false;

  DocumentDetailsData: any[] = [];
  msMeUserName = sessionStorage.getItem('userId');
  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];
  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  DtoPagination =
    {
      "UniqueEventId": '',
      
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }
  dataSource!: MatTableDataSource<IAEventDocumentDetails>
  //displayedColumns: string[] = ['Sr.No', 'IAUserName', 'Intervention', 'Interest', 'CreatedDate', 'DocumentName', 'Download']
  displayedColumns: string[] = ['SrNo', 'DocumentType', 'CreatedDate', 'DocumentName', 'Download', 'Remove'];

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';


  constructor(private apiService: ApiService, private commonService: CommonService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private toastrService: ToastrService,) {

    this.eventUpdationForm = this.fb.group({
      //name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.nameWithSpacePattern)]),
      documents: this.fb.array([this.createDocument()]),
      //docAttendanceName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.nameWithSpacePattern)]),
      attendance: this.fb.array([this.createAttendanceDocument()]),
      //selectedParticipants: this.fb.array([]) // FormArray to hold selected rows
    });

  };

  form1 = new FormGroup({

    searchControl: new FormControl('', [Validators.pattern(this.commonService.searchFilter)])

  })

  get f() {
    return this.eventUpdationForm.controls;
  }

  

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.eventId = params['eventid'];
    });
    /*this.GetEventParticipants();*/
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchTerm = this.commonService.searchText;
  };

  ngAfterViewInit() {
    this.loadEventIADocemntDetails();
  }
 


  // Remove a document entry by index
  //removeDocument(index: number): void {
  //  this.documents.removeAt(index);

  //  // Clear any upload error if the user removed a document and the number is now below the limit
  //  if (this.uploadError && this.documents.length < 5) {
  //    this.uploadError = '';
  //  }
  //}

  removeDocument(index: number): void {
    // Check if it's the last document
    if (this.documents.length === 1) {
      // Show a message if trying to remove the last document
      this.removedocumentuploadError = 'At least 1 record must be present';
      return;
    }

    // Remove the document
    this.documents.removeAt(index);

    // Clear any upload error if the number of documents is now below the limit
    if (this.removedocumentuploadError && this.documents.length < 5) {
      this.removedocumentuploadError = '';
    }
  }

  //removeAttendanceDocument(index: number): void {
  //  this.attendance.removeAt(index);

  //  // Clear any upload error if the user removed a document and the number is now below the limit
  //  if (this.uploadAttError && this.attendance.length < 5) {
  //    this.uploadAttError = '';
  //  }
  //}

  removeAttendanceDocument(index: number): void {
    // Check if it's the last document
    if (this.attendance.length === 1) {
      // Show a message if trying to remove the last onSubmit
      this.uploadAttError = 'At least 1 record must be present';
      return;
    }

    // Remove the document
    this.attendance.removeAt(index);

    // Clear any upload error if the number of documents is now below the limit
    if (this.uploadAttError && this.attendance.length < 5) {
      this.uploadAttError = '';
    }
  }


  // Create a new FormGroup for each document
  createDocument(): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],  // Document name required
      file: [null, Validators.required]  // File input required
    });
  }

  // Create a new FormGroup for each document
  createAttendanceDocument(): FormGroup {
    return this.fb.group({
      docAttendanceName: ['', Validators.required],  // Document name required
      file: [null, Validators.required]  // File input required
    });
  }

  // Getter to access the 'documents' FormArray
  get documents(): FormArray {
    return this.eventUpdationForm.get('documents') as FormArray;
  }

  get attendance(): FormArray {
    return this.eventUpdationForm.get('attendance') as FormArray;
  }

  // Add a new document entry
  addMoreDocuments(): void {
    // Clear any existing error message when the button is clicked
    this.removedocumentuploadError = '';


    if (this.documents.length < 3) {
      this.documents.push(this.createDocument());
    } else {
      this.uploadError = 'You can only add a maximum of 3 documents.'; // Optional error message
    }
  }

  addMoreAttendanceDocuments(): void {
    // Clear any existing error message when the button is clicked
    this.uploadAttError = '';


    if (this.attendance.length < 3) {
      this.attendance.push(this.createAttendanceDocument());
    } else {
      this.uploadAttError = 'You can only add a maximum of 3 documents.'; // Optional error message
    }
  }

   /*Handle file change event and perform validation*/
  //onFileChange(event: any, index: number): void {
  //  const file = event.target.files[0];
  //  const docControl = this.eventUpdationForm.get(`documents.${index}.file`);
  //  const docNameControl = this.eventUpdationForm.get(`documents.${index}.name`);

  //  if (file) {
  //    const maxSizeInMB = 10;
  //    const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB

  //    // Allowed file types
  //    const allowedFileTypes = ['application/pdf', 'image/png', 'image/jpg'];

  //    // Validate file type and size
  //    if (!allowedFileTypes.includes(file.type)) {
  //      this.uploadError = 'Only PDF/PNG/JPG files are allowed.';
  //      docControl?.setValue(null); // Reset file control
  //      docNameControl?.clearValidators(); // Clear name validation if file is invalid
  //      docNameControl?.updateValueAndValidity();
  //    } else if (fileSizeInMB > maxSizeInMB) {
  //      this.uploadError = 'File size should not exceed 10 MB.';
  //      docControl?.setValue(null); // Reset file control
  //      docNameControl?.clearValidators(); // Clear name validation if file size exceeds limit
  //      docNameControl?.updateValueAndValidity();
  //    } else {
  //      this.uploadError = null; // Clear previous errors
  //      docControl?.setValue(file); // Set valid file to the form control
  //      docNameControl?.setValidators([Validators.required]); // Re-validate the name field
  //      docNameControl?.updateValueAndValidity();
  //    }
  //  } else {
  //    docControl?.setValue(null);
  //    docNameControl?.clearValidators();
  //    docNameControl?.updateValueAndValidity();
  //  }
  //}

  onFileChange(event: any, index: number): void {
    const file = event.target.files[0];
    const docControl = this.eventUpdationForm.get(`documents.${index}.file`);
    const docNameControl = this.eventUpdationForm.get(`documents.${index}.name`);

    // Reset previous errors and values
    this.uploadError = null;
    docControl?.setValue(null);
    docControl?.setErrors(null);
    docNameControl?.clearValidators();
    docNameControl?.updateValueAndValidity();

    // File is required
    if (!file) {
      this.uploadError = 'Please upload a file.';
      docControl?.setErrors({ required: true });
      return;
    }

    // Allowed file types
    const allowedFileTypes = ['application/pdf', 'image/png', 'image/jpg', 'image/jpeg'];
    const maxSizeInMB = 10;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024; // Convert MB to Bytes

    // Validate file type
    if (!allowedFileTypes.includes(file.type)) {
      this.uploadError = 'Only PDF, PNG, and JPG files are allowed.';
      docControl?.setErrors({ invalidType: true });
      return;
    }

    // Validate file size
    if (file.size > maxSizeInBytes) {
      this.uploadError = 'File size should not exceed 10 MB.';
      docControl?.setErrors({ maxSize: true });
      return;
    }

    // If valid, update form controls
    docControl?.setValue(file);
    docControl?.setErrors(null);
    docNameControl?.setValidators([Validators.required]);
    docNameControl?.updateValueAndValidity();
  }



  //onAttendanceFileChange(event: any, index: number): void {
  //  const file = event.target.files[0];
  //  const docControl = this.eventUpdationForm.get(`attendance.${index}.file`);
  //  const docNameControl = this.eventUpdationForm.get(`attendance.${index}.name`);

  //  if (file) {
  //    const maxSizeInMB = 10;
  //    const fileSizeInMB = file.size / (1024 * 1024); // Convert to MB

  //    // Validate file type and size
  //    if (file.type !== 'application/pdf') {
  //      this.uploadError = 'Only PDF files are allowed.';
  //      docControl?.setValue(null); // Reset file control
  //      docNameControl?.clearValidators(); // Clear name validation if file is invalid
  //      docNameControl?.updateValueAndValidity();
  //    } else if (fileSizeInMB > maxSizeInMB) {
  //      this.uploadError = 'File size should not exceed 10 MB.';
  //      docControl?.setValue(null); // Reset file control
  //      docNameControl?.clearValidators(); // Clear name validation if file size exceeds limit
  //      docNameControl?.updateValueAndValidity();
  //    } else {
  //      this.uploadError = null; // Clear previous errors
  //      docControl?.setValue(file); // Set valid file to the form control
  //      docNameControl?.setValidators([Validators.required]); // Re-validate the name field
  //      docNameControl?.updateValueAndValidity();
  //    }
  //  } else {
  //    docControl?.setValue(null);
  //    docNameControl?.clearValidators();
  //    docNameControl?.updateValueAndValidity();
  //  }
  //}

  onAttendanceFileChange(event: any, index: number): void {
    const file = event.target.files[0];
    const docControl = this.eventUpdationForm.get(`attendance.${index}.file`);
    const docNameControl = this.eventUpdationForm.get(`attendance.${index}.name`);

    // Reset previous errors and values
    this.uploadError = null;
    docControl?.setValue(null);
    docControl?.setErrors(null);
    docNameControl?.clearValidators();
    docNameControl?.updateValueAndValidity();

    // File is required
    if (!file) {
      this.uploadError = 'Please upload a file.';
      docControl?.setErrors({ required: true });
      return;
    }

    // Allowed file types
    const allowedFileTypes = ['application/pdf'];
    const maxSizeInMB = 10;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024; // Convert MB to Bytes

    // Validate file type
    if (!allowedFileTypes.includes(file.type)) {
      this.uploadError = 'Only PDF file is allowed.';
      docControl?.setErrors({ invalidType: true });
      return;
    }

    // Validate file size
    if (file.size > maxSizeInBytes) {
      this.uploadError = 'File size should not exceed 10 MB.';
      docControl?.setErrors({ maxSize: true });
      return;
    }

    // If valid, update form controls
    docControl?.setValue(file);
    docControl?.setErrors(null);
    docNameControl?.setValidators([Validators.required]);
    docNameControl?.updateValueAndValidity();
  }



  onSubmit() {
    //this.eventId;
    this.loadingSequence = true; // ⬅️ Start loader before anything begins

    if (this.eventUpdationForm.invalid) {
      this.eventUpdationForm.markAllAsTouched();
      this.loadingSequence = false; // ⬅️ Stop loader if OTP failed
      return;
    }
    this.isSubmitting = true; // 🔐 Disable button

    //this.isSubmitted = true;
    if (this.eventUpdationForm.valid) {

      const formData = new FormData();

      // Extract the documents array from the form (form controls under 'documents' FormArray)
      const documents = this.documents.controls.map((docControl: any) => ({
        name: docControl.get('name')?.value,
        file: docControl.get('file')?.value // This will be the file object (PDF)
      }));
      this.document = documents;

      const attandence = this.attendance.controls.map((docControl: any) => ({
        name: docControl.get('docAttendanceName')?.value,
        file: docControl.get('file')?.value // This will be the file object (PDF)
      }));
      this.attendanc = attandence;

      this.document.forEach((doc: { name: string, file: File | null }, index: number) => {
        if (doc.file) {
          formData.append(`documents[${index}].name`, doc.name);
          formData.append(`documents[${index}].file`, doc.file, doc.file.name);
        }
      });

      this.attendanc.forEach((doc: { name: string, file: File | null }, index: number) => {
        if (doc.file) {
          formData.append(`attendances[${index}].name`, doc.name);
          formData.append(`attendances[${index}].file`, doc.file, doc.file.name);
        }
      });

      // Extract selectedParticipants
      //const selectedParticipants = this.eventUpdationForm.get('selectedParticipants')?.value;


      //// Append selected participants to formData
      //selectedParticipants.forEach((participant: any, index: number) => {
      //  formData.append(`selectedParticipants[${index}].UdyamRegistrationNumber`, participant.UdyamRegistrationNumber);
      //  //formData.append(`selectedParticipants[${index}].ParticipantName`, participant.ParticipantName);
      //  //formData.append(`selectedParticipants[${index}].NameOfEnterprise`, participant.NameOfEnterprise);
       
      //  formData.append(`selectedParticipants[${index}].isChecked`, participant.isChecked.toString());
      //});


      formData.append('UniqueEventId', this.eventId);


      // Simulating API call
      this.apiService.postRequest(API_ENDPOINTS.IA.POSTIAEVENTUPDATE, formData).subscribe({
        next: (response) => {
          this.toastrService.success(response.balance.message, 'Success');
          this.router.navigate(['/view_event']);
          this.loadingSequence = false;
        },
        error: (err) => {
          console.error("Error", err);
          this.router.navigate(['/view_event']);
          this.loadingSequence = false;
          this.isSubmitting = false; // ❗ Enable submit again if failed
        },
        complete: () => {
          this.router.navigate(['/view_event']);
          this.loadingSequence = false;
          this.isSubmitting = false; // 🔓 enable again after operation finished
        }
      });
    } else {
      this.eventUpdationForm.markAllAsTouched();
      return;
    }

  }

  ////comment this part
  // GetEventParticipants() {
     
  //  this.apiService.getRequest(API_ENDPOINTS.IA.GETEVENTSPARTICIPANTSDETAILS, { UniqueEventId: this.eventId }).subscribe(
  //    result => {
  //      if (result.status) {
  //        this.reportData = result.data;
  //      }
  //      else {
  //      }
  //     },
  //     (error: any) => {
  //       console.error('Error fetching report data:', error);
  //     }


  //  );
  //}

  //onCheckboxChange(event: Event, udyamRegistrationNumber: string, participantName: string): void {
  //  const checkbox = event.target as HTMLInputElement;
  //  const item = { udyamRegistrationNumber, participantName };

  //  if (checkbox.checked) {
  //    // Add item to the selectedItems array if checked
  //    this.selectedItems.push(item);
  //  } else {
  //    // Remove item from the selectedItems array if unchecked
  //    this.selectedItems = this.selectedItems.filter(
  //      (selected) => selected.udyamRegistrationNumber !== udyamRegistrationNumber
  //    );
  //  }

  //}

  //onCheckboxChange(event: any, udyamRegistrationNumber: string, participantName: string, nameOfEnterprise: string) {
  //  const selectedParticipants = this.eventUpdationForm.get('selectedParticipants') as FormArray;

  //  if (event.target.checked) {
  //    // Add the selected row to the FormArray
  //    selectedParticipants.push(
  //      this.fb.group({
  //        UdyamRegistrationNumber: udyamRegistrationNumber,
  //        ParticipantName: participantName,
  //        NameOfEnterprise: nameOfEnterprise,
  //        isChecked: true
  //      })
  //    );
  //  } else {
  //    // Remove the unselected row from the FormArray
  //    const index = selectedParticipants.controls.findIndex(
  //      (group: any) =>
  //        group.value.UdyamRegistrationNumber === udyamRegistrationNumber
  //    );
  //    if (index !== -1) {
  //      selectedParticipants.removeAt(index);
  //    }
  //  }

  //  // Debug log
  //}


  loadEventIADocemntDetails() {
    this.DtoPagination.UniqueEventId = this.eventId;
    if (!this.pagination) return;
    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService
            .getRequest(API_ENDPOINTS.IA.GETEVENTIADOCUMENTS, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        this.DocumentDetailsData = data;
        this.adjustPaginator();
      });
  }

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  onSearchChange(e: any) {
    this.DtoPagination.SearchTerm = e.target.value;
    this.DtoPagination.PageNumber = 1;
    this.loadEventIADocemntDetails();
  }
  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadEventIADocemntDetails();
  }
  onSearchClick(searchValue: string): void {
    const searchControl = this.form1.get('searchControl');


    if (searchControl?.value && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.loadEventIADocemntDetails();
    } else if (searchValue.trim() === '') {
      searchControl?.markAsTouched();
    } else {
      searchControl?.markAsTouched();
    }
  }

  //commented because harshal said they do not want to delete
  onDelete(fileType: string, fileName: string): void {
    const confirmDelete = confirm("Are you sure you want to permanently delete this record?");
    if (confirmDelete) {
      const payload = {
        UniqueEventId: this.eventId,
        DocumentType: fileType,
        DocumentName: fileName
      };

      this.apiService
        .postRequest(API_ENDPOINTS.IA.REMOVEDOCUMENT, payload)
        .pipe(catchError((error) => {
          console.error("Error deleting document:", error);
          alert("Error deleting document. Please try again.");
          return of(null);
        }))
        .subscribe((resp: any) => {
          if (resp && resp.status) {
            // Find the index of the item to be deleted
            const index = this.DocumentDetailsData.findIndex(doc =>
              doc.DocumentType === fileType && doc.DocumentName === fileName
            );

            // Remove from the local array only if found
            if (index > -1) {
              this.DocumentDetailsData.splice(index, 1);
              this.DocumentDetailsData = [...this.DocumentDetailsData]; // Refresh the table
            }

            alert("Document deleted successfully.");
          } else {
            alert("Error deleting document. Please try again.");
          }
        });
    }
    window.location.reload();
  }

}
